export const receiptLocalization = {
  mentorSupportPayoutTitle: {
    en: 'Payout of support to mentor',
    nb: 'Utbetaling av støtte til mentor',
    nn: 'Utbetaling av støtte til mentor',
  },
  deMinimisAidPayoutTitle: {
    en: 'Payout of support for de minimis aid',
    nb: 'Utbetaling av støtte til bagatellmessig støtte',
    nn: 'Utbetaling av støtte til bagatellmessig støtte',
  },
  maintenancePriorityDeviationTitle: {
    en: 'Priority deviation',
    nb: 'Prioritetsvikelse',
    nn: 'Prioritetsviking',
  },
  genericReceiptHeading: {
    en: 'Receipt',
    nb: 'Kvittering',
    nn: 'Kvittering',
  },
  genericSubmissionSuccessShort: {
    en: 'Submission was successful!',
    nb: 'Innsending er vellykket!',
    nn: 'Innsending er vellykka!',
  },
  contactIfDocumentationMissing: {
    en: 'We will contact you if necessary documentation is missing.',
    nb: 'Vi tar kontakt dersom nødvendig dokumentasjon mangler.',
    nn: 'Vi tek kontakt dersom nødvendig dokumentasjon manglar.',
  },
  backButton: {
    en: 'Back to account overview',
    nb: 'Tilbake til kontooversikt',
    nn: 'Tilbake til kontooversikt',
  },
} as const;
